import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { StyledGrid } from '@Utils/styles';
import { DropDownButton, ZIndex, Text } from '@innovyze/stylovyze';
import { Grid, Stack } from '@mui/material';

export const ActionButton = (
	enabled: boolean,
	selectedStatus: string,
	onGroupActions: (group: boolean, id?: number) => void,
	onExcludeActions: (exclude: boolean, id?: number) => void,
) => {
	const { t } = useGlobalization();

	const actionOptions = () => {
		const options = [];

		if (selectedStatus.includes('g')) {
			options.push({
				onClick: () => {
					onGroupActions(true);
				},
				name: t('Group'),
			});
		} else if (selectedStatus.includes('u')) {
			options.push({
				onClick: () => {
					onGroupActions(false);
				},
				name: t('Ungroup'),
			});
		}

		if (selectedStatus.includes('e')) {
			options.push({
				onClick: () => {
					onExcludeActions(false);
				},
				name: t('Include in Asset Group Set'),
			});
		} else if (selectedStatus.includes('i')) {
			options.push({
				onClick: () => {
					onExcludeActions(true);
				},
				name: t('Exclude from Asset Group Set'),
			});
		}
		return options;
	};

	return (
		<DropDownButton
			key={selectedStatus}
			options={[
				{
					name: t('Action'),
					cy: 'dropdown-Action',
				},
				...actionOptions(),
			]}
			placement="bottom-start"
			switchSelected={false}
			variant="outlined"
			initialSelectedIndex={0}
			color="primary"
			fitMenuToContent
			fitButtonToContent
			disabled={!enabled || selectedStatus === ''}
			popupZIndex={ZIndex.DropDownButtonMenu}
		/>
	);
};

interface TableToolbarProps {
	name: string;
	isLoading: boolean;
	actionEnabled: boolean;
	selectedStatus: string;
	onGroupActions: (group: boolean, id?: number) => void;
	onExcludeActions: (include: boolean, id?: number) => void;
	onRecalculateCount: () => void;
}

export const TableToolbar = ({
	name,
	isLoading,
	actionEnabled,
	selectedStatus,
	onGroupActions,
	onExcludeActions,
}: TableToolbarProps) => {
	const { t } = useGlobalization();

	return (
		<StyledGrid
			container
			style={{
				width: '100%',
				marginTop: '1rem',
				marginBottom: '1rem',
			}}>
			<Grid item xs={6}>
				<Text variant="heading-large-strong">
					{t('{{name}} Values', { name: name })}
				</Text>
				<Text variant="caption-medium">
					{t(
						'These are the ranges that will be used in your asset groups. You can change the number of ranges and edit their values in the table.',
					)}
				</Text>
			</Grid>
			<Grid item xs={6} display="flex" justifyContent="flex-end">
				<Stack direction={'row'} spacing={'20px'}>
					{ActionButton(
						!isLoading && actionEnabled,
						selectedStatus,
						onGroupActions,
						onExcludeActions,
					)}
				</Stack>
			</Grid>
		</StyledGrid>
	);
};
